import React, { useEffect } from "react";
import Navbar from "../Navbar/Navbar";
import Footer from "../Footer/Footer";

// Shared shell for legal documents (Terms, Privacy). Renders an array of
// { heading, body } sections where body is JSX, in a readable prose column.
const LegalLayout = ({ title, subtitle, lastUpdated, sections }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <main className="bg-white">
      <Navbar />

      <section className="relative pt-32 pb-12 lg:pt-40 bg-gray-50 border-b border-gray-100">
        <div className="max-w-3xl mx-auto px-6 lg:px-8">
          <h1 className="text-4xl sm:text-5xl font-bold text-gray-900 tracking-tight">{title}</h1>
          <p className="mt-4 text-lg text-gray-500">{subtitle}</p>
          <p className="mt-6 text-sm text-gray-400">Last updated: {lastUpdated}</p>
        </div>
      </section>

      <section className="py-16 lg:py-20">
        <div className="max-w-3xl mx-auto px-6 lg:px-8">
          <div className="space-y-12">
            {sections.map((section, i) => (
              <div key={i}>
                <h2 className="text-xl font-bold text-gray-900 mb-4">
                  {i + 1}. {section.heading}
                </h2>
                <div className="space-y-4 text-gray-600 leading-relaxed text-[15px]">
                  {section.body}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </main>
  );
};

export default LegalLayout;
